<template>
  <div class="c-product-price-pill">
    <span
      :class="`c-product-price-pill__background-color c-product-price-pill__background-color--${color}`"
    >
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: "ProductPricePill",
  props: {
    color: {
      type: String,
      default: 'black'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-product-price-pill {
  display:inline-block;
  margin-bottom:rem(5px);
  &__background-color {
    min-width:rem(40px);
    padding:  rem(0px) rem(10px) rem(0px) rem(10px);
    border-radius: rem(20px);
    text-transform: uppercase;
    &--red {
      @include themify($themes) {
        background-color: themed('foreground', 'error');
      }
    }
    &--cyan {
      @include themify($themes) {
        background-color: themed('background', 'accent');
      }
    }
  }
}
</style>